module.exports = __webpack_public_path__ + "img/AZ.23687538.png";